import getSplashApiClient from 'lib/SplashApiClient/singleton';
import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const librarianServiceUrl = getBootstrap().get('librarian.serviceUrl');

export default class LibrarianApiClient {
    /**
     * @param {SplashApiClient} apiClient
     * @param {number | string} eventId
     */
    constructor(apiClient, eventId) {
        this.apiClient = apiClient;
        this.eventId = eventId;
        this.requestOptions = {
            headers: {
                'X-Splash-Event-Id': eventId,
            },
        };
    }

    /**
     * GET the admin confirmation styling config associated with a confirmation state
     * @async
     *
     * @param {string} state - confirmation state
     *
     * @returns - JSON document with confirmation styling config plus admin-available meta data
     */
    getAdminEventPageConfirmationByState = async (state) => {
        const url = `/librarian/v1/admin/onPageConfirmations/events/${this.eventId}/${state}`;

        try {
            const response = await this.apiClient.get(url, {}, { ...this.requestOptions });
            return response.data;
        } catch (e) {
            if (e.request.status === 404) {
                return null;
            }

            throw new Error('Server Unavailable');
        }
    };

    /**
     * PUT the new confirmation styling config based on user changes to the style
     * @async
     *
     * @param {string} [options.state] - confirmation state
     * @param {string | number} [options.userId] - confirmation state
     * @param {JSON} [options.document] - cms engine style config
     *
     * @returns - created or updated document ID
     */
    saveEventPageConfirmation = async ({ state, userId, document }) => {
        const saveConfirmationsUrl = `/librarian/v1/admin/onPageConfirmations/events/${this.eventId}/${state}`;

        const saveData = {
            userId: parseInt(userId, 10),
            document: JSON.stringify(document),
        };
        const response = await this.apiClient.put(saveConfirmationsUrl, saveData, { ...this.requestOptions });

        return response.data;
    };

    /**
     * GET the public confirmation styling config associated with a confirmation state
     * @async
     *
     * @param {string} state - confirmation state
     *
     * @returns {ConfirmationsConfig} - JSON document with confirmation styling config
     */
    getPublicEventPageConfirmationByState = async (state) => {
        try {
            const publicConfirmationUrl = `${librarianServiceUrl}/v1/api/onPageConfirmations/events/${this.eventId}/${state}`;

            const response = await axios.get(publicConfirmationUrl, { ...this.requestOptions });

            return response.data.data;
        } catch (error) {
            return null;
        }
    };
}

export const getLibrarianApiClient = (eventId) => new LibrarianApiClient(getSplashApiClient(), eventId);
